module.exports = __webpack_public_path__ + "static/media/mainimg-04.3ede4076.png";